import { render, staticRenderFns } from "./NbPageFooter.vue?vue&type=template&id=48c79225&scoped=true&"
import script from "./NbPageFooter.vue?vue&type=script&lang=js&"
export * from "./NbPageFooter.vue?vue&type=script&lang=js&"
import style0 from "./NbPageFooter.vue?vue&type=style&index=0&id=48c79225&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c79225",
  null
  
)

export default component.exports